// module imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// file imports
import axiosInstance from '@/lib/axios';

const getDashboardStats = createAsyncThunk('adminDashboard/getDashboardStats', async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/admin/dashboard-stats`);
    return response.data;
  } catch (err: any) {
    return rejectWithValue(err.response?.data?.error || 'Retrieving dashboard stats failed');
  }
});

const adminDashboardSlice = createSlice({
  name: 'adminDashboard',
  initialState: {
    data: null as any,
    loading: false,
    error: null as string | null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // getDashboardStats
      .addCase(getDashboardStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDashboardStats.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getDashboardStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError } = adminDashboardSlice.actions;
export { getDashboardStats };
export default adminDashboardSlice.reducer;
